(function (root, factory) {
	var api = factory(root);
	var hasCommonJs = typeof module === 'object' && module && module.exports;

	if (hasCommonJs) {
		module.exports = api;
	} else if (root) {
		root.__CRM_CHUNK_RECOVERY__ = api;
		api.install();
	}
}(typeof window !== 'undefined' ? window : null, function (root) {
	var STATE_KEY = 'crm.chunk-recovery.state.v2';
	var RECOVERY_SCREEN_ID = 'crm-chunk-recovery-screen';
	var RECOVERY_WINDOW_MS = 120000;
	var ASSET_RETRY_PARAM = 'crm_asset_retry';
	var STATIC_ASSET_PATH_RE = /\/static\/(?:js|css)\/.+\.(?:js|css)(?:[?#].*)?$/i;
	var installed = false;

	function createPageId() {
		var timestamp = 0;
		try { timestamp = Date.now ? Date.now() : 0; } catch (_) {}
		return String(timestamp) + '-' + Math.random().toString(36).slice(2, 10);
	}

	function shouldRecoverFromChunkError(error) {
		if (!error) return false;
		var message = error.message || '';
		return error.name === 'ChunkLoadError' || /Loading chunk .+ failed/i.test(message);
	}

	function getErrorFromEvent(event) {
		if (!event) return null;
		return event.error || event.reason || null;
	}

	function extractStaticAssetUrl(event) {
		var target = event && event.target;
		var tagName = target && target.tagName && String(target.tagName).toLowerCase();
		var url;

		if (tagName !== 'script' && tagName !== 'link') return null;
		url = target.currentSrc || target.src || target.href;
		return typeof url === 'string' && STATIC_ASSET_PATH_RE.test(url) ? url : null;
	}

	function isRecoverableEvent(event) {
		return Boolean(extractStaticAssetUrl(event) || shouldRecoverFromChunkError(getErrorFromEvent(event)));
	}

	function readState(storage, now) {
		var state = null;

		try {
			state = JSON.parse(storage && storage.getItem(STATE_KEY));
		} catch (_) {}

		if (!state || typeof state.firstFailureAt !== 'number' || now - state.firstFailureAt > RECOVERY_WINDOW_MS) {
			return { firstFailureAt: now, reloadAttempts: 0, pageId: null, reloadToken: null, assetRetries: {} };
		}
		if (!state.assetRetries || typeof state.assetRetries !== 'object') state.assetRetries = {};

		return state;
	}

	function writeState(storage, state) {
		try {
			if (storage && typeof storage.setItem === 'function') {
				storage.setItem(STATE_KEY, JSON.stringify(state));
			}
		} catch (_) {}
	}

	function clearState(storage) {
		try {
			if (storage && typeof storage.removeItem === 'function') storage.removeItem(STATE_KEY);
		} catch (_) {}
	}

	function cacheBustedUrl(locationObject, now) {
		var url = new URL(locationObject.href);
		url.searchParams.set('v', String(now));
		return url.toString();
	}

	function assetRetryUrl(assetUrl, now) {
		var url = new URL(assetUrl);
		if (url.searchParams.has(ASSET_RETRY_PARAM)) return null;
		url.searchParams.set(ASSET_RETRY_PARAM, String(now));
		return url.toString();
	}

	function retryStaticAsset(event, assetUrl, timestamp, storageObject, state, handlerPageId) {
		var target = event && event.target;
		var tagName = target && target.tagName && String(target.tagName).toLowerCase();
		var propertyName = tagName === 'link' ? 'href' : 'src';
		var retryUrl;
		var onLoad;

		try { retryUrl = assetRetryUrl(assetUrl, timestamp); } catch (_) { return false; }
		if (!retryUrl || !target || state.reloadAttempts > 0 || state.assetRetries[assetUrl]) return false;

		state.pageId = handlerPageId;
		state.assetRetries[assetUrl] = true;
		writeState(storageObject, state);

		onLoad = function () {
			var currentState = readState(storageObject, timestamp);
			delete currentState.assetRetries[assetUrl];
			if (Object.keys(currentState.assetRetries).length === 0 && currentState.reloadAttempts === 0) {
				clearState(storageObject);
			} else {
				writeState(storageObject, currentState);
			}
			if (target.removeEventListener) target.removeEventListener('load', onLoad);
		};
		if (target.addEventListener) target.addEventListener('load', onLoad);
		if (event.preventDefault) event.preventDefault();
		if (event.stopImmediatePropagation) event.stopImmediatePropagation();
		target[propertyName] = retryUrl;
		return true;
	}

	function hasRecoveryToken(locationObject, state) {
		try {
			return Boolean(
				state.reloadToken
				&& new URL(locationObject.href).searchParams.get('v') === String(state.reloadToken)
			);
		} catch (_) {
			return false;
		}
	}

	function applyStyle(element, styles) {
		var key;
		for (key in styles) element.style[key] = styles[key];
	}

	function renderRecoveryScreen(options) {
		var documentObject = options.documentObject;
		var existing = documentObject && documentObject.getElementById(RECOVERY_SCREEN_ID);
		var screen;
		var panel;
		var title;
		var message;
		var detail;
		var button;

		if (!documentObject || !documentObject.body || existing) return existing;

		screen = documentObject.createElement('div');
		screen.id = RECOVERY_SCREEN_ID;
		screen.setAttribute('role', 'alert');
		screen.setAttribute('aria-live', 'assertive');
		applyStyle(screen, {
			position: 'fixed', inset: '0', zIndex: '2147483647', display: 'flex',
			alignItems: 'center', justifyContent: 'center', padding: '24px',
			background: '#f4f6f8', color: '#17202a', fontFamily: 'Arial, sans-serif'
		});

		panel = documentObject.createElement('div');
		applyStyle(panel, {
			width: '100%', maxWidth: '520px', padding: '28px', background: '#ffffff',
			border: '1px solid #d5dbe1', borderRadius: '6px', boxShadow: '0 12px 32px rgba(23, 32, 42, 0.14)'
		});

		title = documentObject.createElement('h1');
		title.textContent = 'CRM тимчасово не завантажилась';
		applyStyle(title, { margin: '0 0 14px', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' });

		message = documentObject.createElement('p');
		message.textContent = 'Не вдалося отримати файли поточної версії. Збережені на сервері дані не втрачено.';
		applyStyle(message, { margin: '0 0 10px', fontSize: '16px', lineHeight: '1.5' });

		detail = documentObject.createElement('p');
		detail.textContent = 'Повторіть завантаження. Якщо оновлення ще триває, зачекайте хвилину і спробуйте знову.';
		applyStyle(detail, { margin: '0 0 22px', fontSize: '14px', lineHeight: '1.5', color: '#52616b' });

		button = documentObject.createElement('button');
		button.type = 'button';
		button.textContent = 'Завантажити CRM повторно';
		applyStyle(button, {
			minHeight: '42px', padding: '10px 18px', border: '0', borderRadius: '4px',
			background: '#0067b8', color: '#ffffff', fontSize: '15px', fontWeight: '600', cursor: 'pointer'
		});
		button.addEventListener('click', function () {
			var timestamp = options.now();
			var state = readState(options.storageObject, timestamp);
			state.reloadToken = String(timestamp);
			writeState(options.storageObject, state);
			try {
				options.replace(cacheBustedUrl(options.locationObject, timestamp));
			} catch (_) {
				options.reload();
			}
		});

		panel.appendChild(title);
		panel.appendChild(message);
		panel.appendChild(detail);
		panel.appendChild(button);
		screen.appendChild(panel);
		documentObject.body.appendChild(screen);
		button.focus();
		return screen;
	}

	function createHandler(options) {
		options = options || {};
		var handlerPageId = createPageId();
		var locationObject = options.locationObject || (root && root.location);
		var storageObject = options.storageObject || (root && root.sessionStorage);
		var documentObject = options.documentObject || (root && root.document);
		var replace = options.replace || function (url) { root.location.replace(url); };
		var reload = options.reload || function () { root.location.reload(); };
		var now = options.now || Date.now;

		return function (event) {
			var timestamp;
			var state;
			var assetUrl;

			assetUrl = extractStaticAssetUrl(event);
			if (!assetUrl && !shouldRecoverFromChunkError(getErrorFromEvent(event))) return false;
			if (!locationObject) return false;
			timestamp = now();
			state = readState(storageObject, timestamp);
			if (state.reloadAttempts > 0 && state.pageId !== handlerPageId && !hasRecoveryToken(locationObject, state)) {
				state = { firstFailureAt: timestamp, reloadAttempts: 0, pageId: null, reloadToken: null, assetRetries: {} };
			}
			if (assetUrl && retryStaticAsset(event, assetUrl, timestamp, storageObject, state, handlerPageId)) {
				return 'asset-retry';
			}

			if (state.reloadAttempts < 1) {
				state.reloadAttempts += 1;
				state.pageId = handlerPageId;
				state.reloadToken = String(timestamp);
				writeState(storageObject, state);
				try {
					replace(cacheBustedUrl(locationObject, timestamp));
				} catch (_) {
					reload();
				}
				return 'reload';
			}

			if (state.pageId === handlerPageId) return 'ignored';
			renderRecoveryScreen({
				documentObject: documentObject,
				locationObject: locationObject,
				storageObject: storageObject,
				replace: replace,
				reload: reload,
				now: now
			});
			return 'fallback';
		};
	}

	function install() {
		var handler;
		if (installed || !root || typeof root.addEventListener !== 'function') return;
		installed = true;
		handler = createHandler();
		root.addEventListener('error', handler, true);
		root.addEventListener('unhandledrejection', handler, true);
	}

	return {
		STATE_KEY: STATE_KEY,
		RECOVERY_SCREEN_ID: RECOVERY_SCREEN_ID,
		shouldRecoverFromChunkError: shouldRecoverFromChunkError,
		extractStaticAssetUrl: extractStaticAssetUrl,
		isRecoverableEvent: isRecoverableEvent,
		createHandler: createHandler,
		renderRecoveryScreen: renderRecoveryScreen,
		clearState: clearState,
		install: install
	};
}));
